export const createLifeCycleUpdater = (roomId, lifeCycleState) => {
  const { stage, step, acceptanceStatus } = lifeCycleState;

  return (rooms) => {
    return rooms.map((room) => {
      if (room.addressId !== roomId) {
        return room;
      }

      const clonedRoom = { ...room };
      const lc = clonedRoom.addressLifeCycle;

      lc.stageAddressLifeCycle = stage;
      lc.stepAddressLifeCycle = step;

      if (acceptanceStatus) {
        lc.acceptanceStatusAddressLifeCycle = acceptanceStatus;
      } else {
        delete lc.acceptanceStatusAddressLifeCycle;
      }

      return clonedRoom;
    });
  };
};
